import React, { useState } from "react";
import { motion } from "framer-motion";
import { X, Loader2 } from "lucide-react";
import { fmt } from "@/lib/storeConfig";

export const ShippingModal = ({ total, busy, onClose, onSubmit }) => {
  const [f, setF] = useState({
    name: "", email: "", phone: "", address1: "", address2: "",
    city: "", state: "", postcode: "", country: "Australia",
  });
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const input = "w-full bg-[#0d0d0d] border border-white/15 focus:border-[#D4AF37] outline-none text-white text-sm px-4 py-3 placeholder:text-white/30 transition-colors";

  const submit = (e) => {
    e.preventDefault();
    onSubmit(f);
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 z-[85] bg-black/85 backdrop-blur-md"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-[86] flex items-center justify-center px-4 pointer-events-none">
        <motion.form
          onSubmit={submit}
          data-testid="shipping-modal"
          initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.3 }}
          className="relative w-full max-w-lg bg-[#0a0a0a] border border-[#D4AF37]/30 p-6 sm:p-8 max-h-[90vh] overflow-y-auto pointer-events-auto"
        >
          <button type="button" data-testid="shipping-modal-close" onClick={onClose} className="absolute top-4 right-4 text-white/60 hover:text-white">
            <X size={20} />
          </button>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">Almost there</p>
          <h2 className="font-display wolf-gold-foil text-3xl mt-2">Where do we ship it?</h2>
          <div className="mt-6 space-y-3">
            <input required data-testid="ship-name" className={input} placeholder="Full name *" value={f.name} onChange={set("name")} />
            <input required type="email" data-testid="ship-email" className={input} placeholder="Email (for order updates) *" value={f.email} onChange={set("email")} />
            <input data-testid="ship-phone" className={input} placeholder="Phone (optional)" value={f.phone} onChange={set("phone")} />
            <input required data-testid="ship-address1" className={input} placeholder="Street address *" value={f.address1} onChange={set("address1")} />
            <input data-testid="ship-address2" className={input} placeholder="Apartment / unit (optional)" value={f.address2} onChange={set("address2")} />
            <div className="grid grid-cols-2 gap-3">
              <input required data-testid="ship-city" className={input} placeholder="Suburb / City *" value={f.city} onChange={set("city")} />
              <input required data-testid="ship-state" className={input} placeholder="State *" value={f.state} onChange={set("state")} />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <input required data-testid="ship-postcode" className={input} placeholder="Postcode *" value={f.postcode} onChange={set("postcode")} />
              <input required data-testid="ship-country" className={input} placeholder="Country *" value={f.country} onChange={set("country")} />
            </div>
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="ship-pay-button"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 text-[12px] uppercase tracking-[0.3em] font-semibold text-black bg-[#D4AF37] hover:bg-[#F4C542] disabled:opacity-40 px-6 py-4 transition-all"
          >
            {busy ? <Loader2 className="animate-spin" size={16} /> : null}
            {busy ? "Redirecting to Stripe…" : `Pay ${fmt(total)} with Stripe`}
          </button>
          <p className="text-[10px] text-white/35 mt-3 text-center uppercase tracking-[0.2em]">Secure payment via Stripe</p>
        </motion.form>
      </div>
    </>
  );
};
